module.exports = __webpack_public_path__ + "static/img/tx004.6461834.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx004.png
// module id = z+96
// module chunks = 1